import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportInventoriesTypes } from "redux/reducers/Reports/reportInventories/types";

const { SET_REPORT_INVENTORIES_FILTERS } = reportInventoriesTypes;

export const getReportInventoriesAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/station-inventory/report-inventories-per-station/${station.id}?initDate=${startDate}&endDate=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Inventario_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportInventories'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportInventories'));
    }
  };
};

export const getReportInventoriesDayAction = ({ date, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/station-inventory/report-inventory-day-per-station/${station.id}?date=${date}&pdf=${isPdf}`;
    const fileName = `Reporte_Inventario_Día_${station.name}_${date}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportInventories'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportInventories'));
    }
  };
};

export const setReportInventoriesFilters = (key = "", value) => {
  return {
    type: SET_REPORT_INVENTORIES_FILTERS,
    payload: { value, key },
  };
};
